import i18n from 'i18n';
function getLikeLabel(likeCount, hasUserLiked) {
  if (likeCount === 0) {
    return i18n.t('no_likes');
  }
  if (hasUserLiked) {
    return likeCount === 1 ? i18n.t('you_have_liked') : i18n.t('you_and_users_have_liked', {
      count: likeCount - 1
    });
  }
  return i18n.t('users_have_liked', {
    count: likeCount
  });
}
export default getLikeLabel;